import {
  ExternalDimensioningConfigurationMismatch,
  ExternalDimensioningConfigurationMismatchError
} from "shared/types/ExternalDimensioning"

export function getExternalDimensioningMismatches(
  error: ExternalDimensioningConfigurationMismatchError | null | undefined
): ExternalDimensioningConfigurationMismatch[] {
  return error?.cause.mismatches.flatMap(mismatch => mismatch.mismatches) ?? []
}
